import React from 'react'

const EOLTestHrdwareSetup = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">EOL Test System</a>
                        <i class="fa fa-angle-right"></i>
                        <span>EOL Test Hardware Setup </span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/eol_test.png' width={400}></img>
                        <img src='/img/eol_test2.jpg' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>EOL-TEST SETUP</h2>
                        <p className="mbot25">
                            As a provider of End-of-Line (EOL) test setups we understand the critical
                            components needed to ensure efficient and accurate testing. This includes
                            the following hardwares and equipment required for a robust EOL test system.
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>Working Table:</h4>
                        <p className="mbot25" >
                            <ul>
                                <li>A sturdy and spacious worktable provides a stable surface for setting up the ECU and connecting test equipment.</li>
                                <li>Features like adjustable height and ESD-safe materials enhance usability.</li>
                            </ul>
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>Conveyor Belt System:</h4>
                        <p className="mbot25" >
                            <ul>
                                <li>The conveyor belt transports the DUT through the testing stations.</li>
                                <li style={{ textDecoration: "underline" }}>Key considerations:</li>
                                <ul>
                                <li>Speed Control: Adjustable conveyor speed to match the testing pace.</li>
                                <li>Alignment: Ensure proper alignment for consistent testing.</li>
                                <li>Safety Features: Emergency stop buttons, safety interlocks, and protective covers.</li>
                                </ul>
                            </ul>
                        </p>
                    </div>
                </div>

                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h4 style={{ textDecoration: "underline" }}>Power Supply Units (PSUs):</h4>
                        <p className="mbot25" >
                            <ul>
                                <li>Reliable and stable power sources are essential for powering the ECUs during testing.</li>
                                <li>Voltage Levels: Different DUTs may require specific voltage levels (e.g., 12V, 24V).</li>
                                <li>Current Capacity: Ensure sufficient current capacity for peak loads.</li>
                                <li>Multiple Outputs: Some DUTs need separate power supplies for different components.</li>
                            </ul>
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>Power Analyzers:</h4>
                        <p className="mbot25" >
                            <ul>
                                <li>These instruments measure power consumption, efficiency, and other electrical parameters.</li>
                                <li>Real-time Monitoring: Track power usage during functional tests.</li>
                                <li>Energy Efficiency Analysis: Assess ECU performance under varying loads.</li>
                                <li>Data Logging: Export power data for analysis and reporting.</li>
                            </ul>
                        </p>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <div>
                            <img src='/img/eol3_test.png' width={600}></img>
                        </div>
                        <div className='mt-4'>
                            <img src='/img/eol4_test.png' width={600}></img>
                        </div>
                    </div>
                </div>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/eol5_test.png' width={400}></img>
                        <img src='/img/eol6_test.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h4 style={{ textDecoration: "underline" }}>Industrial PC (IPC):</h4>
                        <p className="mbot25" >
                            <ul>
                                <li>The IPC serves as the brain of the test system.</li>
                                <li style={{ textDecoration: "underline" }}>Specifications:</li>
                                <ul>
                                    <li>Processing Power: Sufficient CPU and RAM for running test sequences.</li>
                                    <li>I/O Ports: Multiple ports for connecting instruments.
                                        Operating System: Choose a stable OS (e.g., Windows, Linux).</li>
                                </ul>
                            </ul>
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>ESD-Safe Mat:</h4>
                        <p className="mbot25" >
                            <ul>
                                <li>An ESD-safe mat protects sensitive components from electrostatic discharge.</li>
                                <li style={{ textDecoration: "underline" }}>Features:</li>
                                <ul>
                                    <li>Surface Resistance: Low resistance to dissipate static charges.</li>
                                    <li>Grounding Points: Connect to ground to prevent ESD damage.</li>
                                    <li>Size: Large enough to accommodate the test equipment.</li>
                                </ul>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EOLTestHrdwareSetup
